import { DespesaExtra } from '../models';
import { makeCrudObject } from './api';

export default makeCrudObject<DespesaExtra>('despesa-extra');
